import {VillageDeal, VillageDealTranslation} from '@/services/types';

type Props = {
  deals: VillageDeal[];
  lang: string;
};

export default function PromotionContent({deals, lang}: Props) {
  const translations: VillageDealTranslation[] = [];

  deals.flatMap(({deal}) => {
    deal.translation.map((translation) => {
      if (translation.locale === lang) {
        translations.push(translation);
      }
    });
  });

  return (
    <div>
      {translations.map((translation, index) => (
        <div key={index} className="mb-[40px]">
          <span className="inline-block mb-[10px] text-xl font-semibold">
            {translation.title}
          </span>
          <p className="mb-4 leading-[1.6]">{translation.description}</p>
        </div>
      ))}
    </div>
  );
}
